import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/modules/authentication/services/authentication.service';

@Component({
  selector: 'app-user-switch',
  templateUrl: './user-switch.component.html',
  styleUrls: ['./user-switch.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserSwitchComponent {
  public isEnabled = toSignal(this.authenticationService.getUser$()?.pipe(map((u) => u?.multiResource ?? false)));
  public isLoading = signal(false);
  public visible = signal(false);

  constructor(private authenticationService: AuthenticationService) {}
}
